import { render } from "./ServiceTerm.vue?vue&type=template&id=52b1ceca&scoped=true"
import script from "./ServiceTerm.vue?vue&type=script&lang=js"
export * from "./ServiceTerm.vue?vue&type=script&lang=js"

import "./ServiceTerm.vue?vue&type=style&index=0&id=52b1ceca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b1ceca"]])

export default __exports__